import { theme } from 'antd';

const { darkAlgorithm } = theme;

export const lightTheme = {
    token: {
        colorPrimary: '#283AE4',
        colorSuccess: '#00C8B9',
        colorWarning: '#DFAF48',
        colorError: '#D35D5D',
        colorInfo: '#0096FA',
        colorBgBase: '#FFFFFF',
        colorTextBase: '#333333',
    },
    components: {
        Button: {
            colorPrimaryHover: '#0096FA',
        },
        Menu: {
            itemHoverBg: '#F5F5F5',
            colorActiveBar: '#283AE4',
        },
    },
};

export const darkTheme = {
    algorithm: darkAlgorithm,
    token: {
        colorPrimary: '#007ACC',
        colorSuccess: '#0DC8B9',
        colorWarning: '#DFAF48',
        colorError: '#D35D5D',
        colorInfo: '#0096FA',
        colorBgBase: '#1E1E1E',
        colorTextBase: '#CCCCCC',
        colorBorder: '#404040',
        colorBorderSecondary: '#333333',
        colorBgContainer: '#252526',
        colorBgElevated: '#2D2D2D',
        colorBgLayout: '#1E1E1E',
    },
    components: {
        Button: {
            colorPrimaryHover: '#1C97EA',
        },
        Menu: {
            itemHoverBg: '#2A2D2E',
            colorActiveBar: '#007ACC',
        },
        Modal: {
            contentBg: '#252526',
            headerBg: '#252526',
        },
        Table: {
            headerBg: '#252526',
            rowHoverBg: '#2A2D2E',
        },
        Input: {
            colorBgContainer: '#3C3C3C',
        },
        Select: {
            colorBgContainer: '#3C3C3C',
        },
    },
};
